// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-view {
  max-width: 1200px;
  margin: 0 auto;
  animation: fadeIn var(--transition-slow) ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.welcome-section {
  background: var(--surface-card);
  padding: var(--spacing-2xl);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-md);
  margin-bottom: var(--spacing-xl);
  border: 1px solid var(--surface-border);
  transition: all var(--transition-base);
}

.welcome-section:hover {
  box-shadow: var(--shadow-lg);
}

.welcome-section h2 {
  font-size: var(--font-size-3xl);
  color: var(--text-primary);
  margin-bottom: var(--spacing-sm);
  font-weight: 700;
  letter-spacing: -0.02em;
}

.welcome-section p {
  color: var(--text-secondary);
  font-size: var(--font-size-lg);
}

.overview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: var(--spacing-lg);
  margin-top: var(--spacing-xl);
}

@media (max-width: 768px) {
  .overview-grid {
    grid-template-columns: 1fr;
    gap: var(--spacing-md);
  }
}

.overview-card {
  background: var(--surface-card);
  padding: var(--spacing-lg);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--surface-border);
  transition: all var(--transition-base);
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.overview-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--color-primary), var(--color-primary-light));
  transform: translateY(-100%);
  transition: transform var(--transition-base);
}

.overview-card:hover {
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
}

.overview-card:hover::before {
  transform: translateY(0);
}

.overview-card h3 {
  font-size: var(--font-size-xs);
  color: var(--text-secondary);
  font-weight: 600;
  margin-bottom: var(--spacing-sm);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.overview-card .value {
  font-size: var(--font-size-3xl);
  font-weight: 700;
  color: var(--color-secondary);
  line-height: 1;
}

/* Ensure consistent value color */
.overview-card:nth-child(1) .value,
.overview-card:nth-child(2) .value,
.overview-card:nth-child(3) .value,
.overview-card:nth-child(4) .value { color: var(--color-secondary); }

/* Dashboard modules layout */
.dashboard-modules {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xl);
}

@media (max-width: 1200px) {
  .dashboard-modules {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;EAC5B,gCAAgC;EAChC,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;AACF;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,uCAAuC;EACvC,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oFAAoF;EACpF,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA,kCAAkC;AAClC;;;qCAGqC,6BAA6B,EAAE;;AAEpE,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".dashboard-view {\n  max-width: 1200px;\n  margin: 0 auto;\n  animation: fadeIn var(--transition-slow) ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.welcome-section {\n  background: var(--surface-card);\n  padding: var(--spacing-2xl);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-md);\n  margin-bottom: var(--spacing-xl);\n  border: 1px solid var(--surface-border);\n  transition: all var(--transition-base);\n}\n\n.welcome-section:hover {\n  box-shadow: var(--shadow-lg);\n}\n\n.welcome-section h2 {\n  font-size: var(--font-size-3xl);\n  color: var(--text-primary);\n  margin-bottom: var(--spacing-sm);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.welcome-section p {\n  color: var(--text-secondary);\n  font-size: var(--font-size-lg);\n}\n\n.overview-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: var(--spacing-lg);\n  margin-top: var(--spacing-xl);\n}\n\n@media (max-width: 768px) {\n  .overview-grid {\n    grid-template-columns: 1fr;\n    gap: var(--spacing-md);\n  }\n}\n\n.overview-card {\n  background: var(--surface-card);\n  padding: var(--spacing-lg);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--surface-border);\n  transition: all var(--transition-base);\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.overview-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, var(--color-primary), var(--color-primary-light));\n  transform: translateY(-100%);\n  transition: transform var(--transition-base);\n}\n\n.overview-card:hover {\n  box-shadow: var(--shadow-md);\n  transform: translateY(-2px);\n}\n\n.overview-card:hover::before {\n  transform: translateY(0);\n}\n\n.overview-card h3 {\n  font-size: var(--font-size-xs);\n  color: var(--text-secondary);\n  font-weight: 600;\n  margin-bottom: var(--spacing-sm);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.overview-card .value {\n  font-size: var(--font-size-3xl);\n  font-weight: 700;\n  color: var(--color-secondary);\n  line-height: 1;\n}\n\n/* Ensure consistent value color */\n.overview-card:nth-child(1) .value,\n.overview-card:nth-child(2) .value,\n.overview-card:nth-child(3) .value,\n.overview-card:nth-child(4) .value { color: var(--color-secondary); }\n\n/* Dashboard modules layout */\n.dashboard-modules {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-xl);\n}\n\n@media (max-width: 1200px) {\n  .dashboard-modules {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
